module.exports = __webpack_public_path__ + "assets/media/lunch.376db68c.mp3";